import { NavigationGuardNext, Route } from 'vue-router';
import { AccountType } from '@/core/enums/account-type';

export const profileAddLinkedAccountResolver = async (
	to: Route,
	_: Route,
	next: NavigationGuardNext,
): Promise<void> => {
	const { type, fid } = to.query;

	if (!type) {
		next({ name: 'ProfileAccounts' });
		return;
	}

	if (type === AccountType.LOAN && !fid) {
		next({ name: 'ProfileAccounts' });
	}
};
